import React from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import BroadcastMessagingOverview from "./BroadcastMessagingOverview";
import BroadcastMessaging from "./BroadcastMessaging";

export default function BroadcastMessagingReport() {
  return (
    <div className="row g-5 ">
      <div>
        <BroadcastMessaging />
      </div>

      {/* <div>
        <BroadcastMessagingOverview />
      </div> */}
    </div>
  );
}
